/** Already-formatted decimal plus currency. USD is `$` and the code; others are the code only. */
export function formatAmountWithCode(amount: string, currency: string): string {
  const code = currency.trim().toUpperCase();
  if (!code) return amount;
  return code === "USD" ? `$${amount} ${code}` : `${amount} ${code}`;
}
